import React from 'react';
export const Testimonials = () => {
  return <section className="w-full bg-white py-10 px-4" data-id="element-373">
      <div className="max-w-4xl mx-auto" data-id="element-374">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-6 text-center" data-id="element-375">
          Des Résultats Qui Redonnent Espoir
        </h2>
        <div className="grid md:grid-cols-2 gap-6 mb-8" data-id="element-376">
          <div className="bg-blue-50 p-6 rounded-lg shadow-sm" data-id="element-377">
            <div className="flex items-start mb-4" data-id="element-378">
              <img src="https://images.unsplash.com/photo-1581579438747-99076a6d8336?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80" alt="Denise" className="w-16 h-16 rounded-full mr-4 object-cover" data-id="element-379" />
              <div data-id="element-380">
                <h3 className="font-bold text-lg text-gray-800" data-id="element-381">
                  Denise, 71 ans, Laval
                </h3>
                <p className="text-blue-700 font-bold" data-id="element-382">
                  "J'ai évité l'amputation"
                </p>
              </div>
            </div>
            <p className="text-gray-700 mb-4 italic" data-id="element-383">
              "Mes pieds étaient complètement engourdis depuis 8 mois. Mon
              diabétologue parlait déjà d'amputation préventive. J'ai essayé
              KinéPulse par désespoir.
            </p>
            <p className="text-gray-700 mb-4 italic" data-id="element-384">
              Après 3 semaines, j'ai senti mes orteils bouger pour la première
              fois. Aujourd'hui, 6 mois plus tard, je remarche normalement. Mon
              diabétologue n'en revient pas."
            </p>
            <div className="bg-white p-3 rounded" data-id="element-385">
              <p className="font-bold" data-id="element-386">
                Évaluation de sensibilité : Passée de 0/10 à 8/10
              </p>
            </div>
          </div>
          <div className="bg-blue-50 p-6 rounded-lg shadow-sm" data-id="element-387">
            <div className="flex items-start mb-4" data-id="element-388">
              <img src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80" alt="Robert" className="w-16 h-16 rounded-full mr-4 object-cover" data-id="element-389" />
              <div data-id="element-390">
                <h3 className="font-bold text-lg text-gray-800" data-id="element-391">
                  Robert, 68 ans, Québec
                </h3>
                <p className="text-blue-700 font-bold" data-id="element-392">"Je ne boite plus"</p>
              </div>
            </div>
            <p className="text-gray-700 mb-4 italic" data-id="element-393">
              "Diabétique depuis 15 ans, je boitais à cause des douleurs de
              brûlure constantes. Les médicaments me rendaient zombie.
            </p>
            <p className="text-gray-700 mb-4 italic" data-id="element-394">
              Avec KinéPulse, les brûlures ont disparu en 5 semaines. Je dors
              enfin toute la nuit. Ma femme dit que j'ai retrouvé ma joie de
              vivre."
            </p>
            <div className="bg-white p-3 rounded" data-id="element-395">
              <p className="font-bold" data-id="element-396">
                Réduction de la douleur : 85% en 2 mois
              </p>
            </div>
          </div>
        </div>
        <div className="bg-white border border-blue-200 p-6 rounded-lg shadow-sm mb-8" data-id="element-397">
          <div className="flex items-start mb-4" data-id="element-398">
            <img src="https://images.unsplash.com/photo-1594824476967-48c8b964273f?ixlib=rb-4.0.3&auto=format&fit=crop&w=200&q=80" alt="Dr. Marie Dubois" className="w-16 h-16 rounded-full mr-4 object-cover" data-id="element-399" />
            <div data-id="element-400">
              <h3 className="font-bold text-lg text-gray-800" data-id="element-401">
                Dr. Marie Dubois, Clinique du Pied, Québec :
              </h3>
            </div>
          </div>
          <p className="text-gray-700 mb-4 italic" data-id="element-402">
            "Je recommande maintenant KinéPulse à tous mes patients
            neuropathiques. C'est la première fois en 15 ans de pratique que je
            vois des patients récupérer de la sensibilité.
          </p>
          <p className="text-gray-700 italic" data-id="element-403">
            Trois de mes patients ont évité l'amputation grâce à cet appareil.
            Les résultats sont mesurables et reproductibles."
          </p>
        </div>
        <div className="bg-blue-600 text-white p-6 rounded-lg" data-id="element-404">
          <h3 className="text-xl font-bold mb-4" data-id="element-405">
            Résultats de Notre Étude Pilote (127 patients québécois, 90 jours) :
          </h3>
          <ul className="space-y-3" data-id="element-406">
            <li className="flex items-start" data-id="element-407">
              <div className="h-6 w-6 rounded-full bg-white text-blue-600 flex items-center justify-center mr-3 mt-1 flex-shrink-0 font-bold" data-id="element-408">
                ✓
              </div>
              <p data-id="element-409">89% ont retrouvé au moins 50% de leur sensibilité</p>
            </li>
            <li className="flex items-start" data-id="element-410">
              <div className="h-6 w-6 rounded-full bg-white text-blue-600 flex items-center justify-center mr-3 mt-1 flex-shrink-0 font-bold" data-id="element-411">
                ✓
              </div>
              <p data-id="element-412">76% ont pu arrêter ou réduire leurs médicaments</p>
            </li>
            <li className="flex items-start" data-id="element-413">
              <div className="h-6 w-6 rounded-full bg-white text-blue-600 flex items-center justify-center mr-3 mt-1 flex-shrink-0 font-bold" data-id="element-414">
                ✓
              </div>
              <p data-id="element-415">94% ont retrouvé un sommeil normal</p>
            </li>
            <li className="flex items-start" data-id="element-416">
              <div className="h-6 w-6 rounded-full bg-white text-blue-600 flex items-center justify-center mr-3 mt-1 flex-shrink-0 font-bold" data-id="element-417">
                ✓
              </div>
              <p data-id="element-418">AUCUNE amputation n'a été nécessaire dans le groupe test</p>
            </li>
          </ul>
        </div>
      </div>
    </section>;
};